module.exports = __webpack_public_path__ + "img/2.6a6658b8.webp";